import { ToastContainer, toast } from 'react-toastify';

type Type = 'info' | 'success' | 'warning' | 'error';

export const notify = (message: string, options: { type?: Type } = {}) =>
  toast[options.type ?? 'info'](message);

/**
 * Renders at the app root, on both the Tailwind landing pages and the MUI
 * dashboard, so it must not depend on either theme provider. Colors are the
 * brand palette constants (themes/colors.ts equivalents), fixed at build.
 */
const TOAST_CSS = `
.Toastify__toast { min-height: 40px; border-radius: 8px; }
.Toastify__toast--success { background-color: #ecfdf5; }
.Toastify__toast--success svg { fill: #10b981; }
.Toastify__progress-bar--success { background-color: #10b981; }
.Toastify__toast--info { background-color: #eff6ff; }
.Toastify__toast--info svg { fill: #3b82f6; }
.Toastify__progress-bar--info { background-color: #3b82f6; }
.Toastify__toast--warning { background-color: #fffbeb; }
.Toastify__toast--warning svg { fill: #f79009; }
.Toastify__progress-bar--warning { background-color: #f79009; }
.Toastify__toast--error { background-color: #fef2f2; }
.Toastify__toast--error svg { fill: #f04438; }
.Toastify__progress-bar--error { background-color: #f04438; }
.Toastify__close-button > svg { fill: #1a202c; }
`;

export const ToastProvider = () => (
  <>
    <style>{TOAST_CSS}</style>
    <ToastContainer draggable stacked position="top-center" />
  </>
);
